/**
 * 活动展示状态（与首页角标、右下角文案一致）
 * ENDED 已结束 | IN_PROGRESS 进行中 | NOT_STARTED 未开始 | REG_CLOSED 已截止（报名已截止且未处于进行中）
 */

export function getActivityBadgeKey(item, nowMs = Date.now()) {
  const t = nowMs;
  const start = item?.startAt ? new Date(item.startAt).getTime() : null;
  const end = item?.endAt ? new Date(item.endAt).getTime() : null;
  const signup = item?.signupDeadline
    ? new Date(item.signupDeadline).getTime()
    : null;

  if (end != null && !Number.isNaN(end) && t > end) return "ENDED";
  if (
    start != null &&
    end != null &&
    !Number.isNaN(start) &&
    !Number.isNaN(end) &&
    t >= start &&
    t <= end
  ) {
    return "IN_PROGRESS";
  }
  if (start != null && !Number.isNaN(start) && t < start) {
    if (signup == null || Number.isNaN(signup) || t <= signup)
      return "NOT_STARTED";
    return "REG_CLOSED";
  }
  if (signup != null && !Number.isNaN(signup) && t > signup)
    return "REG_CLOSED";
  return "NOT_STARTED";
}

export const ACTIVITY_BADGE_LABEL = {
  ENDED: "已结束",
  IN_PROGRESS: "进行中",
  NOT_STARTED: "未开始",
  REG_CLOSED: "已截止",
};

/** 右下角：ratio 显示 n/max；over 显示 OVER */
export function getActivityCornerMode(item, nowMs = Date.now()) {
  const key = getActivityBadgeKey(item, nowMs);
  if (key === "ENDED" || key === "REG_CLOSED") return "over";
  return "ratio";
}

/** 报名人数占比颜色：≤60% 绿色，>60% 红色 */
export function getEnrollmentRatioClass(enrolled, max) {
  const m = Number(max) > 0 ? Number(max) : 0;
  const e = Number(enrolled) || 0;
  if (m <= 0) return "ratio--neutral";
  const ratio = e / m;
  return ratio > 0.6 ? "ratio--high" : "ratio--low";
}

export function canSignupClient(item, nowMs = Date.now()) {
  const key = getActivityBadgeKey(item, nowMs);
  if (key === "ENDED" || key === "REG_CLOSED") return false;
  const t = nowMs;
  const end = item?.endAt ? new Date(item.endAt).getTime() : null;
  if (end != null && !Number.isNaN(end) && t > end) return false;
  const signup = item?.signupDeadline
    ? new Date(item.signupDeadline).getTime()
    : null;
  if (signup != null && !Number.isNaN(signup) && t > signup) return false;
  const max =
    Number(item?.maxParticipants) > 0 ? Number(item.maxParticipants) : Infinity;
  const enrolled = Number(item?.enrolledCount) || 0;
  return enrolled < max;
}

/** 已报名且处于活动时间内：可显示「立即进入」 */
export function canEnterActivity(item, nowMs = Date.now()) {
  const t = nowMs;
  const start = item?.startAt ? new Date(item.startAt).getTime() : null;
  const end = item?.endAt ? new Date(item.endAt).getTime() : null;
  if (start == null || end == null || Number.isNaN(start) || Number.isNaN(end))
    return false;
  return t >= start && t <= end;
}
